<template>
    <div class="common-fission-list">
        <template v-if="data && data.length > 0">
            <div class="list-wrap" ref="listContainer" @scroll="handleScroll">
                <div v-for="(item, index) in data" :key="getItemKey(item, index)" class="list-item">
                    <div class="item-content">
                        <div class="item-content-left">
                            <div class="avatar">
                                <img :src="item.icon || defaultIcon" alt="" />
                            </div>
                            <div class="user-info-wrapper">
                                <div class="user-info">{{ getUserInfo(item) }}</div>
                                <div class="time-info" v-if="item.update_time">
                                    {{ formatTime(item.update_time) }}
                                </div>
                            </div>
                        </div>
                        <div class="item-content-right" v-html="item.content"></div>
                    </div>
                </div>
            </div>
        </template>
        <div v-else class="empty-tip" v-html="emptyContent"></div>
    </div>
</template>

<script >
import { defineEmits, defineProps, onMounted, onUnmounted, ref } from 'vue-demi';
import defaultIcon from '../assets/images/defaultIcon.png';
import { UID_MASK_END, UID_MASK_START } from '../assets/scripts/constants';
import { formatTime } from '../assets/scripts/utils';
const __sfc_main = {};
__sfc_main.props = {
  // 列表数据
  data: {
    type: Array,
    default: () => []
  },
  // 是否还有更多数据
  hasMore: {
    type: Boolean,
    default: false
  },
  emptyContent: {
    type: String,
    default: '暂无数据'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const listContainer = ref(null);
  const isLoading = ref(false); // 防止重复加载

  // 加载超时时间（毫秒）
  const LOAD_TIMEOUT = 1000;

  // 获取列表项的 key，优先使用 item 的 id 或 uid，否则使用 index
  const getItemKey = (item, index) => {
    return item?.id ?? item?.uid ?? index;
  };

  // 获取用户信息显示文本
  const getUserInfo = item => {
    const {
      nick,
      uid
    } = item;
    if (!nick && !uid) {
      return '';
    }
    const uidStr = uid ? uid.toString() : '';
    if (uidStr) {
      return `${nick || ''}(${uidStr.slice(0, UID_MASK_START)}***${uidStr.slice(-UID_MASK_END)})`;
    }
    return nick || '';
  };

  // 处理滚动事件
  const handleScroll = () => {
    if (!props.hasMore || isLoading.value) {
      return;
    }
    const container = listContainer.value;
    if (!container) {
      return;
    }

    // 计算是否滚动到底部（距离底部 50px 时触发加载）
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;
    const threshold = 50; // 距离底部 50px 时触发

    if (scrollTop + clientHeight >= scrollHeight - threshold) {
      isLoading.value = true;
      emit('load-more', () => {
        console.log('load-more callback');
        isLoading.value = false;
      });

      // 如果父组件没有及时更新 hasMore，则在指定时间后自动重置（防止一直处于 loading 状态）
      setTimeout(() => {
        isLoading.value = false;
      }, LOAD_TIMEOUT);
    }
  };
  onMounted(() => {
    // 组件挂载后可以执行一些初始化操作
  });
  onUnmounted(() => {
    // 清理工作
  });
  return {
    defaultIcon,
    formatTime,
    listContainer,
    getItemKey,
    getUserInfo,
    handleScroll
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.common-fission-list {
    width: 100%;
    height: 100%;
    display: flex;
    -webkit-overflow-scrolling: touch; // iOS 平滑滚动

    .list-wrap {
        width: 100%;
        background-color: #fff;
        border-radius: 0.3rem;
        padding: 0.28rem 0.33rem;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
    }

    .list-item {
        width: 100%;

        &:not(:last-child) {
            .item-content {
                border-bottom: 0.01rem solid #e5e5e5;
            }
        }

        .item-content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.3rem 0;
            width: 100%;

            .item-content-left {
                flex: 1;
                min-width: 0;
                display: flex;
                align-items: center;
                margin-right: 0.2rem;

                .avatar {
                    width: 0.62rem;
                    height: 0.62rem;
                    border-radius: 50%;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: linear-gradient(180deg, #e6e6e6 0%, #bababa 100%);
                    flex-shrink: 0;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .user-info-wrapper {
                    margin-left: 0.1rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    min-width: 0;

                    .user-info {
                        font-weight: 400;
                        font-size: 0.28rem;
                        color: #262626;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }

                    .time-info {
                        margin-top: 0.08rem;
                        font-weight: 400;
                        font-size: 0.22rem;
                        color: #999;
                        white-space: nowrap;
                    }
                }
            }

            .item-content-right {
                flex-shrink: 0;
                max-width: 100%;
                white-space: normal;
                word-wrap: break-word;
                word-break: break-word;
                text-align: right;
            }
        }
    }

    .empty-tip {
        width: 100%;
        padding: 0.5rem;
        text-align: center;
        color: #999;
        font-size: 0.28rem;
        align-self: center;
    }
}
</style>
